export const fnExt = {
    scrollTop: function (amount) {
        // when an amount is passed in, we set the scroll position
        if (amount !== undefined) {
            if (this.is(window)) {
                window.scrollTo(0, amount);
            } else {
                this.prop('pageYOffset', amount);
                this.get(0).scroll({
                    top: amount,
                    behavior: 'smooth',
                });
            }
        }
        return (this.is(window) ? this.prop('pageYOffset') : this[0] && this[0].scrollTop) || 0;
    },
    scrollLeft: function (amount) {
        // when an amount is passed in, we set the scroll position
        if (amount !== undefined) {
            if (this.is(window)) {
                window.scrollTo(amount, 0);
            } else {
                this.prop('pageXOffset', amount);
                this.get(0) &&
                    this.get(0).scroll({
                        left: amount,
                        behavior: 'smooth',
                    });
            }
        }
        return (this.is(window) ? this.prop('pageXOffset') : this[0] && this[0].scrollLeft) || 0;
    },
};
